import React, { useContext, useEffect, useRef, useState } from "react";
import { GetEditorForm } from "../../core/Helper2";
import { PatientObj, PatientService } from "../../model/backoffice/patient";
import { FormObjectService } from "../../core/FieldObject";
import FormAutoObject from "../../core/FormAutoObject";
import { useDispatch, useSelector } from "react-redux";

import {
  AlertError,
  AlertOK,
  FormatThaiCard3,
  MysqlDateCV,
  ThaicardToNumber,
} from "../../core/Helper";
import { Button } from "react-bootstrap";
import { FaRegIdCard } from "react-icons/fa";
import useWebSocket from "react-use-websocket";
import { Oval } from "react-loading-icons";
import { DefaultState } from "../components/SearchBigData";
import { PrefixService, SearchPrefix } from "../../model/prefix";
import SearchTypeB from "../components/SearchTypeB";
import { CardReadCommandContext, PersonInfoContext } from "../../App";

export default function PatientEditor(props) {
  const [editor, setEditor] = props?.editor;
  const [objField, setObjField] = useState([]);
  const [form, setForm] = useState(null); //** Form objects */
  const [data, setData] = useState([]); //** Form data */
  const [subLoading, setSubLoading] = useState(false);
  const refForm1 = useRef();
  const userInfo = useSelector((state) => state.user.detail);
  const [searchB, setSearchB] = useState(DefaultState);
  const dispatch = useDispatch();

  const cardReaderCmd = useContext(CardReadCommandContext);
  const personInfo = useContext(PersonInfoContext);

  useEffect(() => {
    if (editor?.show) {
      if (personInfo?.IdCardNo !== 0) {
        setData(personInfo);
      }
      setSubLoading(false);
    }
  }, [personInfo]);

  /**Form init*/
  useEffect(() => {
    if (editor?.show) {
      buildForm();
      if (editor?.idValue > 0) {
        getOldData();
      }
    }
    return () => {
      setData([]);
    };
  }, [editor?.show]);

  const prefixClick = (item) => {
    SearchPrefix([setSearchB, data, setData, userInfo, item]);
  };

  /* formats id-card */
  const idCardChanged = (value, item) => {
    var idcard = FormatThaiCard3(value);
    setData((pv) => ({ ...pv, [item.fieldName]: idcard }));
  };
  /** Build Form objects */
  const buildForm = async () => {
    setObjField(
      await FormObjectService.BuildsFormOBJs(
        PatientObj({
          prefixClick,
          idCardChanged,
        })
      )
    );
  };

  const getOldData = async () => {
    let ret = await PatientService.GetItem(
      { [editor.idFieldName]: editor.idValue },
      userInfo
    );
    if (ret) {
      setData(ret);
    }
  };

  /** Render form */
  const renderForm = async () => {
    setForm(
      <FormAutoObject
        {...{ items: objField, dataValue: [data, setData], refTo: refForm1 }}
      />
    );
  };

  /** SAVE */
  const actionSave = async () => {
    let fData1 = { ...data, [editor.idFieldName]: editor.idValue };
    fData1.IdCardNo = ThaicardToNumber(fData1.IdCardNo);
    //console.log(fData1);
    //   FormObjectService.ConvertSwitchON2Boolean(fData1);

    if (fData1.IdCardNo === "") {
      AlertError("กรุณาระบุเลขที่บัตร", dispatch);
      return;
    }

    if (!fData1.Firstname) {
      AlertError("กรุณาระบุชื่อคนไข้", dispatch);
      return;
    }
    if (!fData1.Lastname) {
      AlertError("ระบุนามสกุลคนไข้", dispatch);
      return;
    }

    if (fData1.FirstnameEng === "") {
      AlertError("กรุณาระบุชื่อคนไข้ภาษาอังกฤษ", dispatch);
      return;
    }

    if (fData1.Prefix.PrefixID === 0) {
      AlertError("กรุณาระบุคำนำหน้า", dispatch);
      return;
    }

    if (fData1.PrefixEn.PrefixID === 0) {
      AlertError("กรุณาระบุคำนำหน้าภาษาอังกฤษ", dispatch);
      return;
    }

    let ret = await PatientService.SaveItem(fData1, userInfo);
    // console.log(ret);

    if (ret != null) {
      if (ret?.Message == "Error") {
        AlertError(ret?.Data ?? "พบปัญหาการบันทึก", dispatch);
        return;
      }

      AlertOK("บันทึกเรียบร้อย", dispatch);
      editor.action();
      setEditor({ show: false });
    }
  };

  /** Build Form */
  useEffect(() => {
    renderForm();
  }, [objField, data, subLoading]);

  const { sendMessage, readyState } = cardReaderCmd;
  const readsCard = async () => {
    if (readyState !== 1) {
      AlertError("ไม่พบเครื่องอ่านบัตร", dispatch);
      return;
    }
    setSubLoading(true);
    sendMessage("RequestID");
  };

  // RETURN OBJECT
  return (
    <div>
      <GetEditorForm
        {...{
          title: "เพิ่มแก้ไขข้อมูลคนไข้",
          editor: [editor, setEditor],
          form: [form, setForm],
          saveData: actionSave,
          footerLeft: (
            <Button variant="outline-primary" onClick={() => readsCard()}>
              {subLoading ? (
                <Oval height={25} />
              ) : (
                <FaRegIdCard style={{ marginInlineEnd: "10px" }} size={25} />
              )}
              อ่านจากเครื่องรูตบัตร
            </Button>
          ),
        }}
      />
      <SearchTypeB {...{ winState: [searchB, setSearchB] }} />
    </div>
  );
}

const example1 = {
  Citizenid: "3669900173154",
  PhotoRaw: null,
  PhotoBitmap: null,
  Address: "303 หมู่ที่ 2    ตำบลไหล่หิน อำเภอเกาะคา จังหวัดลำปาง",
  addrHouseNo: "303",
  addrVillageNo: "หมู่ที่ 2",
  addrLane: "",
  addrRoad: "",
  addrTambol: "ตำบลไหล่หิน",
  addrAmphur: "อำเภอเกาะคา",
  addrProvince: "จังหวัดลำปาง",
  Issue: "2022-04-26T00:00:00",
  Expire: "2030-06-05T00:00:00",
  ExpireString: "25730605",
  Birthday: "1981-06-06T00:00:00",
  BirthdayYearString: "1981",
  Sex: "2",
  Th_Prefix: "นาง",
  Th_Firstname: "พนารัตน์",
  Th_Middlename: "",
  Th_Lastname: "ทานัง",
  En_Prefix: "Mrs.",
  En_Firstname: "Panarat",
  En_Middlename: "",
  En_Lastname: "Tanang",
  Issuer: "อำเภอเกาะคา/ลำปาง",
};

const example2 = {
  Citizenid: "3411100909061",
  PhotoRaw: null,
  PhotoBitmap: null,
  Address: "20 หมู่ที่ 1   ตำบลอ้อมกอ อำเภอบ้านดุง จังหวัดอุดรธานี",
  addrHouseNo: "20",
  addrVillageNo: "หมู่ที่ 1",
  addrLane: "",
  addrRoad: "",
  addrTambol: "ตำบลอ้อมกอ",
  addrAmphur: "อำเภอบ้านดุง",
  addrProvince: "จังหวัดอุดรธานี",
  Issue: "2016-06-07T00:00:00",
  Expire: "2025-05-23T00:00:00",
  ExpireString: "25680523",
  Birthday: "1978-05-24T00:00:00",
  BirthdayYearString: "1978",
  Sex: "1",
  Th_Prefix: "นาย",
  Th_Firstname: "ศุภชัย",
  Th_Middlename: "",
  Th_Lastname: "ทานัง",
  En_Prefix: "Mr.",
  En_Firstname: "Supachai",
  En_Middlename: "",
  En_Lastname: "Tanang",
  Issuer:
    "อำเภอเกาะคา/ลำปาง                                                                                   ",
};
